export enum AllocationGetterEnum {
  ALLOCATIONS = 'allocations'
}
